import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Link as MuiLink, Typography, Box } from '@mui/material';

const buttonResetSx = {
    border: 'none',
    background: 'none',
    font: 'inherit',
    textAlign: 'inherit',
};

const MenuLink = ({ to, href, onClick, icon, children, sx = {}, ...rest }) => {
    const isHashLink = to === '#' || href === '#';
    const hasRoute = Boolean(to && !isHashLink);
    const hasHref = Boolean(href && !isHashLink);

    const linkProps = hasRoute
        ? { component: RouterLink, to }
        : hasHref
            ? { href }
            : { component: 'button', type: 'button' };

    const handleClick = (event) => {
        if (isHashLink) {
            event.preventDefault();
        }
        onClick?.(event);
    };

    return (
        <MuiLink
            {...linkProps}
            onClick={handleClick}
            underline='none'
            sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'center',
                width: 'auto',
                gap: '4px',
                padding: 0,
                cursor: 'pointer',
                color: '#171718',
                fontSize: '18px',
                lineHeight: '140%',
                textDecoration: 'none',
                boxSizing: 'border-box',
                borderBottom: '1px solid transparent',
                '&:hover': {
                    color: '#054CCC',
                    borderBottom: '1px solid #054CCC',
                    textDecoration: 'none',
                },
                '&:active': {
                    color: '#054CCC',
                    borderBottom: '1px solid #054CCC',
                    textDecoration: 'none',
                },
                ...(!hasRoute && !hasHref ? buttonResetSx : {}),
                ...sx,
            }}
            {...rest}
        >
            {icon ? (
                <Box
                    component='span'
                    sx={{
                        width: 16,
                        height: 16,
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'inherit',
                        '& svg': {
                            width: '100%',
                            height: '100%',
                            color: 'inherit',
                        },
                        '& svg path': {
                            fill: 'currentColor',
                        },
                        '& svg [stroke]': {
                            stroke: 'currentColor',
                        },
                    }}
                >
                    {icon}
                </Box>
            ) : null}
            <Typography sx={{ fontFamily: 'Roboto, sans-serif', fontWeight: 400, fontSize: 'inherit', lineHeight: 'inherit', color: 'inherit' }}>
                {children}
            </Typography>
        </MuiLink>
    );
};

export default MenuLink;
